import { render, staticRenderFns } from "./MarketingList.vue?vue&type=template&id=e075568c&"
import script from "./MarketingList.vue?vue&type=script&lang=js&"
export * from "./MarketingList.vue?vue&type=script&lang=js&"
import style0 from "./MarketingList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports